/**
 * Finish lists come from catalogue_items.finish on the matched Canvas row.
 * Comparison ignores hyphen/space punctuation; display keeps the catalogue spelling.
 */
export function normalizeCanvasFinishKey(value: string | null | undefined): string {
  return String(value ?? "")
    .trim()
    .toLowerCase()
    .replace(/[-–—_]+/g, " ")
    .replace(/\s+/g, " ");
}

export function parseCanvasFinishChoices(raw: string | null | undefined): string[] {
  const seen = new Set<string>();
  const out: string[] = [];
  for (const part of String(raw ?? "").split(/[/|;,]+/)) {
    const label = part.trim();
    if (!label) continue;
    const key = normalizeCanvasFinishKey(label);
    if (!key || seen.has(key)) continue;
    seen.add(key);
    out.push(label);
  }
  return out;
}

export function canvasFinishChoicesFromRow(row: { finish?: string | null }): {
  choices: string[];
  malformed: boolean;
} {
  const choices = parseCanvasFinishChoices(row.finish);
  return { choices, malformed: choices.length === 0 };
}

export function matchCanvasFinishToRow(
  row: { finish?: string | null },
  selected: string | null | undefined,
): string | null {
  const wanted = normalizeCanvasFinishKey(selected);
  if (!wanted) return null;
  return parseCanvasFinishChoices(row.finish).find((choice) => normalizeCanvasFinishKey(choice) === wanted) ?? null;
}
